import type { CandidateProvider } from 'components/Keyboard/modules/candidates';

import { getPinyinCandidates } from '../Pinyin/provider';
import { segmentZhuyin, zhuyinToPinyin } from './utils';

export const formatZhuyinDisplay = (composing: string): string => segmentZhuyin(composing).join(' ');

export const getZhuyinCandidates: CandidateProvider = async (buffer, maxResults, keyboard) => {
  if (!buffer) {
    return [];
  }

  const syllables = zhuyinToPinyin(buffer);
  if (!syllables.length) {
    return [];
  }
  return getPinyinCandidates(syllables.join(''), maxResults, keyboard);
};